import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { FeesRoutingModule } from './fees-routing.module';
import { FeesListComponent } from './fees-list/fees-list.component';
import { FeesCreateComponent } from './fees-create/fees-create.component';

@NgModule({
  declarations: [FeesListComponent, FeesCreateComponent],
  imports: [
    CommonModule,
    FeesRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class FeesModule { }
